import TZDate from './TZDate';
import { formatTZDate } from './dateHelpers';
import { DEFAULT_TIME_FORMAT, DEFAULT_DATE_FORMAT } from './static';
import { OPENED } from './openingHours';
import { translate } from '../translations';

function isInUnderSixDays(date1, date2) {
  const diff = Math.abs(date1.diff(date2));
  const diffInDays = diff / 1000 / 60 / 60 / 24;

  return diffInDays < 6;
}

function isToday(date1, date2) {
  return date1.isSameDay(date2);
}

function isTomorrow(date1, date2) {
  return date1.addDays(1).isSameDay(date2);
}

export function createBadgeTextLines(
  openingState,
  zoneInfo,
  lang,
  timeFormat,
  dateFormat
) {
  const currentDate = new TZDate(Date.now(), zoneInfo);
  const { openingDate, closingDate } = openingState;
  const isOpen = openingState.status === OPENED;

  if (isOpen) {
    const line0 = translate('open_standalone', lang); // This should be used if the word 'Open' is not part of the sentence "Yes, we're Open"
    const line1 = translate('yes_we_are', lang);
    const line2 = translate('open', lang);

    const closingTimeFormated = closingDate &&
      formatTZDate(closingDate, timeFormat, DEFAULT_TIME_FORMAT);

    const closingDateFormated = closingDate &&
      formatTZDate(closingDate, dateFormat, DEFAULT_DATE_FORMAT);

    const closingDayId = closingDate &&
      closingDate.getDayString().toLowerCase();
    const closingDayFormated = closingDayId && translate(closingDayId, lang);

    if (!closingDate) {
      // open 24/7
      return {
        line0,
        line1,
        line2,
        line3: translate('twentyfourseven', lang),
        line4: ''
      };
      // TODO: re-add support for this case
      //} else if (isInUnderAnHour(currentDate, closingDate)) {
      // closing in under 60 minutes
      //  return {
      //    line0,
      //    line1,
      //    line2,
      //    line3: translate('closing', lang),
      //    line4: closingDate.locale(lang).fromNow()
      //  };
    } else if (isToday(currentDate, closingDate)) {
      // closing today
      return {
        line0,
        line1,
        line2,
        line3: translate('closing', lang),
        line4: translate('at_x', lang, {
          x: closingTimeFormated
        }) // TODO: add arguments
      };
    } else if (isTomorrow(currentDate, closingDate)) {
      // closing tomorrow
      return {
        line0,
        line1,
        line2,
        line3: translate('closing_tomorrow', lang),
        line4: translate('at_x', lang, {
          x: closingTimeFormated
        })
      };
    } else if (isInUnderSixDays(currentDate, closingDate)) {
      // closing in under 7 days
      return {
        line0,
        line1,
        line2,
        line3: translate('closing_x', lang, {
          x: closingDayFormated,
          isWeekday: true
        }), // TODO: add arguments
        line4: translate('at_x', lang, {
          x: closingTimeFormated
        })
      };
    } else {
      // closing sometime later in the future
      return {
        line0,
        line1,
        line2,
        line3: translate('closing_x', lang, {
          x: closingDateFormated
        }),
        line4: translate('at_x', lang, {
          x: closingTimeFormated
        })
      };
    }
  } else {
    const line0 = translate('closed_standalone', lang); // This should be used if the word 'Closed' is not part of the sentence "Sorry, we're Closed"
    const line1 = translate('sorry_we_are', lang);
    const line2 = translate('closed', lang);

    const openingTimeFormated = openingDate &&
      formatTZDate(openingDate, timeFormat, DEFAULT_TIME_FORMAT);
    // moment.tz(openingDate.getTimestamp(), zoneInfo.name).format(timeFormat);
    const openingDateFormated = openingDate &&
      formatTZDate(openingDate, dateFormat, DEFAULT_DATE_FORMAT);
    // moment.tz(openingDate.getTimestamp(), zoneInfo.name).format(dateFormat);
    const openingDayId = openingDate &&
      openingDate.getDayString().toLowerCase();
    const openingDayFormated = openingDayId && translate(openingDayId, lang);

    if (!openingDate) {
      // closed forever
      return {
        line0,
        line1,
        line2,
        line3: '',
        line4: ''
      };
      // TODO: re-add support for this case
      //} else if (isInUnderAnHour(currentDate, openingDate)) {
      //  opening in under 60 minutes
      //  return {
      //  line0,
      //  line1,
      //  line2,
      //  line3: translate('opening', lang),
      //  line4: openingDate.locale(lang).fromNow()
      //  };
    } else if (isToday(currentDate, openingDate)) {
      // opening today
      return {
        line0,
        line1,
        line2,
        line3: translate('opening', lang),
        line4: translate('at_x', lang, {
          x: openingTimeFormated
        })
      };
    } else if (isTomorrow(currentDate, openingDate)) {
      // opening tomorrow
      return {
        line0,
        line1,
        line2,
        line3: translate('opening_tomorrow', lang),
        line4: translate('at_x', lang, {
          x: openingTimeFormated
        })
      };
    } else if (isInUnderSixDays(currentDate, openingDate)) {
      // opening in under 7 days
      return {
        line0,
        line1,
        line2,
        line3: translate('opening_x', lang, {
          x: openingDayFormated,
          isWeekday: true
        }),
        line4: translate('at_x', lang, {
          x: openingTimeFormated
        })
      };
    } else {
      // opening sometime later in the future
      return {
        line0,
        line1,
        line2,
        line3: translate('opening_x', lang, {
          x: openingDateFormated
        }),
        line4: translate('at_x', lang, {
          x: openingTimeFormated
        })
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/commons/services/badgeText.js